export default [
  //Un-Optimized Pages in "Content"
  "/author/course",
  "/manage/content/author/lesson",
  "/author/section",
  "/author/subcourse"
]
